<template>
    <div class="card mb-3">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">手術基本資料</h5>
            <button class="btn btn-outline-primary" @click="showDetailModal = true">
                <i class="fas fa-edit me-1"></i>詳細資訊
            </button>
        </div>
        <div class="card-body">
            <!-- Summary View -->
            <div class="row">
                <div class="col-md-3 mb-3">
                    <label class="form-label text-muted">病歷編號</label>
                    <div class="fw-bold fs-5">{{ modelValue.medical_record_sn || '-' }}</div>
                </div>
                <div class="col-md-3 mb-3">
                    <label class="form-label text-muted">物種</label>
                    <div class="fw-bold fs-5">{{ modelValue.species || '-' }}</div>
                </div>
                <div class="col-md-3 mb-3">
                    <label class="form-label text-muted">體重 (kg)</label>
                    <div class="fw-bold fs-5">{{ modelValue.BW_actual || '-' }}</div>
                </div>
                <div class="col-md-3 mb-3">
                    <label class="form-label text-muted">麻醉類型</label>
                    <div class="fw-bold fs-5">{{ $parameters.anesthesiaTypeList.find(item => item.id === modelValue.anesthesia_type)?.name || '-' }}</div>
                </div>
            </div>
        </div>

        <!-- Detail Modal -->
        <transition name="modal-bounce">
            <div class="modal fade show" v-if="showDetailModal" style="display: block;" tabindex="-1">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">編輯手術基本資料</h5>
                            <button type="button" class="btn-close" @click="showDetailModal = false"></button>
                        </div>
                        <div class="modal-body p-4">
                            <div class="row">
                                <div class="col-md-4 mb-3">
                                    <label class="form-label">病歷編號</label>
                                    <input type="text" class="form-control" v-model="modelValue.medical_record_sn" disabled>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label class="form-label">物種</label>
                                    <input type="text" class="form-control" v-model="modelValue.species" disabled>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label class="form-label">體重 (kg)</label>
                                    <input type="number" class="form-control" v-model="modelValue.BW_actual" disabled>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label">手術類型</label>
                                    <input type="text" class="form-control"
                                    :value="anesthesiaTypeName"
                                    disabled>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label">手術日期</label>
                                    <input type="date" class="form-control" 
                                        disabled
                                        :value="modelValue.surgery_date"
                                    >
                                </div>
                                <div class="col-md-3 mb-3">
                                    <label class="form-label">主刀醫師</label>
                                     <input type="text" class="form-control" v-model="modelValue.chief_surgeon_name" disabled>
                                </div>
                                <div class="col-md-3 mb-3">
                                    <label class="form-label">副刀醫師</label>
                                    <input type="text" class="form-control" v-model="modelValue.assistant_surgeon_name" disabled>
                                </div>
                                <div class="col-md-3 mb-3">
                                    <label class="form-label">麻醉醫師</label>
                                    <input type="text" class="form-control" v-model="modelValue.anesthesiologist_name" disabled>
                                </div>
                                <div class="col-md-3 mb-3">
                                    <label class="form-label">麻醉助手</label>
                                    <input type="text" class="form-control" v-model="modelValue.anesthesia_assistant" disabled>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">喉管尺寸</label>
                                    <input type="text" class="form-control" :value="tubeSizeName" disabled>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">手術內容</label>
                                    <input type="text" class="form-control" v-model="modelValue.surgical_details" disabled>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'SurgeryInfo',
    props: {
        modelValue: {
            type: Object,
            required: true,
            default: () => ({
                medical_record_sn: '',
                species: '',
                surgery_date: '',
                anesthesia_type: -1, //麻醉類型
                tube_size: -1, //喉管尺寸
                BW_estimate: 0, //預估體重
                BW_actual: 0, //實際體重
                chief_surgeon: -1, //主刀
                assistant_surgeon: -1, //副刀
                anesthesiologist: -1, //麻醉師
                anesthesia_assistant: -1, //麻醉助手
                surgical_details: '', //手術細節
                photo_url_json: `[]`
            })
        },
        doctorList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            showDetailModal: false
        }
    },
    computed: {
        anesthesiaTypeName() {
            return this.$parameters.anesthesiaTypeList.find(item => item.id === this.modelValue.anesthesia_type)?.name || '-'
        },
        tubeSizeName() {
            return this.$parameters.tubeSizeList.find(item => item.id === parseInt(this.modelValue.tube_size))?.name || '-'
        }
    }
}
</script>

<style scoped>
/* Reuse modal animation */
.modal-bounce-enter-active, .modal-bounce-leave-active {
    transition: opacity 0.3s ease;
}
.modal-bounce-enter-from, .modal-bounce-leave-to {
    opacity: 0;
}

.modal-bounce-enter-active .modal-content {
    animation: slide-down 0.4s ease-out;
}
.modal-bounce-leave-active .modal-content {
    animation: slide-down 0.3s ease-in reverse;
}

@keyframes slide-down {
    0% {
        transform: translateY(-50px);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}
</style>
